import React, { useEffect } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import NotFound from './pages/NotFound'
import { getEnv } from './utils/environment'
import BaseContextWrapper from './components/common/BaseContext'
import { LanguageProvider } from './contexts/LanguageContext'
import Login from './pages/Login'
import ProtectedRoute from './components/common/ProtectedRoute'
import SettingsUser from './pages/settings/SettingsUser'
import Currency from './pages/settings/Income'
import AnimalType from './pages/settings/AnimalType'
import Expenses from './pages/expenses/Expenses'
import Animals from './pages/animals/Animals'
import AnimalTypes from './pages/animals/AnimalTypes'
import AnimalDetail from './pages/animals/AnimalDetail'
import Home from './pages/Home'
import Earnings from './pages/earnings/earnings'
import Category from './pages/settings/category/category'
import Calculator from './pages/calculator/Calculator'
import TechCategory from './pages/settings/tech-category/TechCategory'
import Tech from './pages/tech/Tech'
import Salary from './pages/salary/Salary'
import Users from './pages/settings/users/Users'
import Employee from './pages/employee/Employee'
import TechOwn from './pages/own/TechOwn'
import SecretCode from './pages/settings/secret-code/SecretCode'
import Privacy from './pages/Privacy'
import Support from './pages/Support'
import DeleteAccount from './pages/DeleteAccount'
// Farm (dala boshqaruvi) — izolyatsiyalangan modul (backend: /api/farm/)
import FarmFields from './pages/farm/Fields'
import FarmFieldDetail from './pages/farm/FieldDetail'
import FarmReports from './pages/farm/Reports'
import FarmMapAll from './pages/farm/MapAll'
import FarmSettings from './pages/farm/Settings'

export default function App() {
    useEffect(() => {
        if (getEnv() === 'production') return
        document.title = `${getEnv().toUpperCase()} ${document.title}`
    }, [])

    return (
        <LanguageProvider>
            <BrowserRouter>
                <BaseContextWrapper>
                    <Switch>
                        <Route path="/" component={Login} exact />
                        <Route path="/privacy" component={Privacy} exact />
                        <Route path="/support" component={Support} exact />
                        <Route path="/delete-account" component={DeleteAccount} exact />
                        <ProtectedRoute path="/home" component={Home} exact />
                        <ProtectedRoute path="/expense-report" component={Expenses} exact />
                        <ProtectedRoute path="/animals/type/:typeId" component={Animals} exact />
                        <ProtectedRoute path="/animals/:id" component={AnimalDetail} exact />
                        <ProtectedRoute path="/animals" component={AnimalTypes} exact />
                        <ProtectedRoute path="/tech" component={Tech} exact />
                        <ProtectedRoute path="/own-tech" component={TechOwn} exact />
                        <ProtectedRoute path="/employee/salary/:employeeId" component={Salary} exact />
                        <ProtectedRoute path="/employee" component={Employee} exact />
                        <ProtectedRoute path="/earnings" component={Earnings} exact />
                        <ProtectedRoute path="/calculator" component={Calculator} exact />
                        <ProtectedRoute path="/farm" component={FarmFields} exact />
                        <ProtectedRoute path="/farm/reports" component={FarmReports} exact />
                        <ProtectedRoute path="/farm/map" component={FarmMapAll} exact />
                        <ProtectedRoute path="/farm/settings" component={FarmSettings} exact />
                        <ProtectedRoute path="/farm/fields/:id" component={FarmFieldDetail} exact />
                        <ProtectedRoute path="/settings/user" component={SettingsUser} exact />
                        <ProtectedRoute path="/settings/secret-code" component={SecretCode} exact />
                        <ProtectedRoute path="/settings/income" component={Currency} exact />
                        <ProtectedRoute path="/settings/animal-type" component={AnimalType} exact />
                        <ProtectedRoute path="/settings/category" component={Category} exact />
                        <ProtectedRoute path="/settings/tech-category" component={TechCategory} exact />
                        <ProtectedRoute path="/users" component={Users} exact />
                        <Route path="" component={NotFound} exact />
                    </Switch>
                </BaseContextWrapper>
            </BrowserRouter>
        </LanguageProvider>
    )
}
